// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2Srbv","error":"Textarea_error__2Ngyp","readonly":"Textarea_readonly__1_739","disabled":"Textarea_disabled__uS2mv"};